import React, { FC } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../constants';
import { BellActiveIcon, BellIcon, DotRedIcon } from '../../assets/svg';

interface UpdatesButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
  isUpdatesAvailable: boolean;
  isUpdatesShown: boolean;
}

export const UpdatesButton: FC<UpdatesButtonProps> = ({
  onClick,
  isUpdatesAvailable,
  isUpdatesShown,
}) => {
  const dotRedStyles: React.CSSProperties = {
    display: isUpdatesAvailable ? 'block' : 'none',
    position: 'absolute' as const,
    top: '15px',
    right: '13px',
  };
  
  return (
    <UpdateButtonContainer
      onClick={onClick}
      disabled={!isUpdatesAvailable}
      $isUpdatesShown={isUpdatesShown}
      $isUpdatesAvailable={isUpdatesAvailable}
    >
      {isUpdatesShown ? <BellActiveIcon /> : <BellIcon />}
      <DotRedIcon style={dotRedStyles} />
    </UpdateButtonContainer>
  );
};

const UpdateButtonContainer = styled.button<{
  $isUpdatesShown: boolean;
  $isUpdatesAvailable: boolean;
}>`
  width: 44px;
  aspect-ratio: 1 / 1;
  background-color: ${({ $isUpdatesShown }) =>
    $isUpdatesShown ? COLORS.MAIN_RED_OPACITY : COLORS.WHITE};
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  border-color: ${COLORS.MAIN_RED};
  position: relative;
  cursor: ${({ $isUpdatesAvailable }) =>
    $isUpdatesAvailable ? 'pointer' : 'default'};
`;
